import { useRef, useState } from "react";
import { api } from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Loader2, Volume2 } from "lucide-react";

export const READ_VOICES = [
  { id: "nova", label: "Nova · warm" },
  { id: "shimmer", label: "Shimmer · gentle" },
  { id: "fable", label: "Fable · playful" },
  { id: "alloy", label: "Alloy · neutral" },
  { id: "onyx", label: "Onyx · deep" },
  { id: "echo", label: "Echo · steady" },
];

export const SPEEDS = [
  { id: "0.75", label: "0.75× slow" },
  { id: "1", label: "1× normal" },
  { id: "1.25", label: "1.25× brisk" },
  { id: "1.5", label: "1.5× fast" },
];

export const VoicePreview = ({ voice, testid = "voice-preview" }) => {
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);

  const play = async () => {
    if (ref.current) {
      ref.current.pause();
      ref.current = null;
    }
    setBusy(true);
    try {
      const { data } = await api.get(`/voices/${voice}/preview`, { responseType: "blob" });
      const audio = new Audio(URL.createObjectURL(data));
      ref.current = audio;
      await audio.play();
    } catch (err) {
      console.error("Could not play that audio:", err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      data-testid={testid}
      onClick={play}
      title="Hear this voice"
      className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/10 text-ink-soft transition-colors hover:bg-white/20 hover:text-brand"
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Volume2 className="h-4 w-4" />}
    </button>
  );
};

export const SpeedSelect = ({ value, onChange, testid = "speed-select" }) => (
  <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
    <SelectTrigger data-testid={testid} className="h-9 w-[124px] rounded-full text-xs">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {SPEEDS.map((s) => (
        <SelectItem key={s.id} value={s.id} data-testid={`${testid}-${s.id}`}>
          {s.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
